import React from "react";

import { Dialog } from "primereact/dialog";
import { T } from "services/lang/LanguageService";
import DashboardHistoryTable from "./DashboardHistoryTable";

type DashboardHistoryDialogProps = {
  openDialog: boolean;
  setOpenDialog: React.Dispatch<React.SetStateAction<boolean>>;
};

const DashboardHistoryDialog: React.FC<DashboardHistoryDialogProps> = ({
  openDialog,
  setOpenDialog,
}) => {
  return (
    <Dialog
      header={T("header.dashboard-history")}
      visible={openDialog}
      style={{ minWidth: "min(100%, 700px)" }}
      onHide={() => setOpenDialog(false)}
    >
      <DashboardHistoryTable closeDialog={() => setOpenDialog(false)}/>
    </Dialog>
  );
};

export default DashboardHistoryDialog;
